export default {
    'widgets.wallet-view.wallet-subtitle': 'wallets',
    'widgets.wallet-list.agreements-main': 'By connecting your wallet, you agree\nto our ',
    'widgets.wallet-list.agreements-terms': 'Terms of Services',
    'widgets.wallet-list.agreements-and': ' and ',
    'widgets.wallet-list.agreements-privacy': 'Privacy Policy',
    'widgets.wallet-manager-route.wallets.manager': 'Wallet management',
    'widgets.wallet-manager-route.wallets.connect': 'Connect wallet',
    'widgets.wallet-manager-route.wallets.qrcode.wallet-connect': 'Wallet Connect',
    'widgets.wallet-manager-route.wallets.disconnect': 'Disconnect wallet',
    'widgets.wallet-manager-route.account': 'Account',
    'widgets.wallet-manager.button.disconnect': 'Disconnect all wallets',
    'widgets.wallet-disconnect.button.disconnect': 'Disconnect',
    'widgets.wallet-disconnect.button.cancel': 'Cancel',
    'widgets.wallet-disconnect.msg.single-wallet': 'Do you really want to disconnect wallet?',
    'widgets.wallet-disconnect.msg.all-wallets': 'Do you really want to disconnect all wallets?',
    'widgets.wallet-disconnect.msg.some-wallet': 'Do you really want to disconnect ',
    'widgets.wallet-qrcode.title': 'Scan with your wallet',
    'widgets.wallet-qrcode.button.copy': 'Copy to Clipboard',
    'widgets.wallet-qrcode.button.alternative-connection': 'Open in Wallet Connect',
};
//# sourceMappingURL=en.js.map